import { axiosClient } from './base'

export const listComapnyUsers = (companyId, { pageNumber, pageSize, q }) => axiosClient.get(`/admin/api/company/${companyId}/user`, {
  params: {
    pageNumber,
    pageSize,
    q
  }
})
